var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('video',{ref:"videoPlayer",staticClass:"video-js",attrs:{"playsinline":""}}),_vm._v(" "),_c('video-vertical-watermark',{attrs:{"width":_vm.width,"heigth":_vm.height,"mode":"center"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9dc6e694","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/VideoPlayer.vue
// module id = null
// module chunks = 